// extracted by mini-css-extract-plugin
export const sm = "768px";
export const md = "992px";
export const lg = "1440px";
export const xl = "1920px";
export const xlMin = "1920px";
export const lgMax = "1919px";
export const lgMin = "1440px";
export const mdMax = "1439px";
export const mdMin = "992px";
export const smMax = "991px";
export const smMin = "768px";
export const xsMax = "767px";
export const handheld = "992px";
export const headerMax = "1366px";
export const headerHeightMax = "650px";
export const desktopHeaderMin = "1367px";